import {BACKEND_URL} from "@/config/config";

export const ROUTES = {
    SUBSCRIBER_CREATE: () => {
        return BACKEND_URL + 'subscriber/create'
    },
    SUBSCRIBER_CONFIRM: () => {
        return BACKEND_URL + 'subscriber/confirm'
    }
}